import React from 'react';
import { CustomFieldFilter } from '../CustomFieldFilter';
import { CustomField, CustomFieldType, CustomFieldValue } from '../../../../../types/custom_field/customField';
import { CustomFieldFilterBooleanContent } from './CustomFieldFilterBooleanContent';
import { CustomFieldFilterDateContent } from './CustomFieldFilterDateContent';
import { BaseFilterProps } from '../../common/BaseFilter';
import { CustomFieldFilterListOfValuesContent } from './CustomFieldFilterListOfValuesContent';
import { CustomFieldTextContent } from './CustomFieldFilterTextContent';
import { CustomFieldFilterListOfTuplesContent } from './CustomFieldFilterListOfTuplesContent';

interface CustomFieldFilterDropdownContentProps {
  customField: CustomField;
  filter: CustomFieldFilter;
  props: BaseFilterProps;
  defaultElement: JSX.Element;
  customFieldValues: CustomFieldValue[];
}

export function CustomFieldFilterDropdownContent({
  customField,
  filter,
  props,
  defaultElement,
  customFieldValues,
}: CustomFieldFilterDropdownContentProps) {
  if (props.filterProps.customFieldValues && !props.filterProps.customFieldValues.size) {
    props.setFilterProps({ ...props.filterProps, customFieldValues: undefined });
  }

  switch (customField.type) {
    case CustomFieldType.bool:
      return (
        <CustomFieldFilterBooleanContent
          customField={customField}
          filter={filter}
          filterProps={props.filterProps}
          setFilterProps={props.setFilterProps}
        />
      );
    case CustomFieldType.listOfValues:
      return (
        <CustomFieldFilterListOfValuesContent
          customField={customField}
          filter={filter}
          filterProps={props.filterProps}
          setFilterProps={props.setFilterProps}
        />
      );
    case CustomFieldType.listOfTuples:
      return (
        <CustomFieldFilterListOfTuplesContent
          customField={customField}
          filter={filter}
          filterProps={props.filterProps}
          setFilterProps={props.setFilterProps}
        />
      );
    case CustomFieldType.text:
      return (
        <CustomFieldTextContent
          customField={customField}
          filter={filter}
          filterProps={props.filterProps}
          setFilterProps={props.setFilterProps}
          customFieldValues={customFieldValues}
        />
      );
    case CustomFieldType.date:
      return <CustomFieldFilterDateContent customField={customField} props={props} />;
  }

  return defaultElement;
}
